__turbopack_context__.v({
  "bottom": "_9sMNtG_bottom",
  "left": "_9sMNtG_left",
  "right": "_9sMNtG_right",
  "tooltip": "_9sMNtG_tooltip",
  "tooltip-title": "_9sMNtG_tooltip-title",
  "tooltip-wrapper": "_9sMNtG_tooltip-wrapper",
  "top": "_9sMNtG_top",
});
